<template>
    <div>
        <div class="invoice-page-info">
            <div class="manage-main">
                <div class="rule" style="display: flex;background: #fff;">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">发票信息</div>
						<div class="right-body">
                            <div class="invoice-info-item">
						        <div class="item-label">抬头类型：</div>
						        <div class="item-input">
						        	<label for="kind1"><input v-model="form.InvoiceTitle" id="kind1" name="kind" type="radio" :value="0">单位</label>
                                    <label for="kind2"><input v-model="form.InvoiceTitle" id="kind2" name="kind" type="radio" :value="1">个人</label>
						    	</div>
						    	<div class="item-tip"></div>
						    </div>
						    <div class="invoice-info-item">
						        <div v-if="form.InvoiceTitle == 0" class="item-label">单位名称</div>
						        <div v-if="form.InvoiceTitle == 1" class="item-label">姓名</div>
						        <div class="item-input input-box"><input v-model="form.InvoiceName" type="text" placeholder="发票抬头"></div>
						        <div class="item-tip">必填</div>
						    </div>
						    <div class="invoice-info-item">
						        <div class="item-label">发票金额</div>
						        <div class="item-input input-box"><input v-model="form.Accounts" type="text" readonly placeholder="若不填写,默认为全额发票"></div>
						        <div class="item-tip">元,已选账单可以开票金额：<span>{{form.Accounts}}</span></div>
						    </div>
							<div class="invoice-info-item">
						        <div class="item-label">发票项目</div>
						        <div class="item-input input-box item-select">
									<select v-model="form.InvoiceItem">
										<option :value="0">代订房费</option>
										<option :value="1">代订住宿费</option>
                                	</select>
								</div>
						    </div>
						    <div class="invoice-info-item">
						        <div class="item-label">发票种类</div>
								<div class="item-input input-box item-select">
									<select v-model="form.InvoiceKind">
										<option :value="0">电子普通发票</option>
										<!-- <option :value="1">增值税专用发票</option> -->
									</select>
								</div>
						    	<div class="item-tip"></div>
						    </div>
						    <div class="invoice-info-item" v-if="form.InvoiceTitle == 0">
						        <div class="item-label">纳税人识别号</div>
						        <div class="item-input input-box"><input v-model="form.TaxpayerIdentifyNo" type="text" placeholder="输入长度不能超过20位"></div>
						        <div class="item-tip">必填</div>
						    </div>
						    <div v-if="form.InvoiceKind == 0" class="invoice-info-item">
						        <div class="item-label">邮箱地址</div>
						        <div class="item-input input-box"><input v-model="form.Email" type="text"></div>
						        <div class="item-tip">必填</div>
						    </div>
							<!-- <div v-if="form.InvoiceKind == 1" class="invoice-info-item">
								<div class="item-label">收件人</div>
								<div class="item-input input-box"><input v-model="form.UserName" type="text"></div>
								<div class="item-tip">必填</div>
							</div>
							<div v-if="form.InvoiceKind == 1" class="invoice-info-item">
								<div class="item-label">电话</div>
								<div class="item-input input-box"><input v-model="form.Phone" type="text"></div>
								<div class="item-tip">必填</div>
							</div>
							<div v-if="form.InvoiceKind == 1" class="invoice-info-item">
								<div class="item-label">地址</div>
								<div class="item-input input-box"><input v-model="form.Address" type="text"></div>
								<div class="item-tip">必填</div>
							</div> -->
						    <div class="invoice-info-item">
						        <div class="item-label">发票备注</div>
						        <div class="input-note"><input v-model="form.Remark" type="textarea" style="width:500px; padding:20px; font-size:16px;" placeholder="所填内容将会显示在发票上"></div>
						        <div class="item-tip">选填</div>
						    </div>
							<div class="buttom">
								<div class="save" @click="saveInfo">保存</div>
								<div class="reset" @click="reset">重置</div>
							</div>
						</div>
                    </div>
                </div>
            </div>
        </div>
		<Modal v-show="modal.show" :config="modal"></Modal>
    </div>
</template>

<script>
import Menu from "./../../common/cmpnt/menu/Menu";
import Modal from "./../../common/cmpnt/Modal/modal.vue"; //跳转提示框

export default {
  name: "invoice",
  components: {
    Menu,
    Modal
  },
  data() {
    return {
      form: {
        OrderOrBillNo: this.$route.query.no,
        InvoiceTitle: 0,
        InvoiceName: "",
        Accounts: "",
        InvoiceItem: 0,
        InvoiceType: 0,
        InvoiceKind: 0,
        TaxpayerIdentifyNo: "",
        Email: "",
        Remark: "",
        SettlementType: "",
        UserName: "",
        Phone: "",
        Address: ""
      },
      modal: {
        show: false,
        config: {}
      }
    };
  },
  mounted() {
    document.title = "发票信息";
    this.form.Accounts = this.$route.query.amount;
    this.form.SettlementType = parseInt(this.$route.query.type);
  },
  methods: {
    saveInfo() {
      let that = this;
      that.modal = {
        show: true,
        content: "正在为您开票，请稍后...."
      };
      //  请求接口的参数 接口文档上的Body Parametears 里面的字段
      let param = {
        OrderOrBillNo: this.form.OrderOrBillNo,
        InvoiceTitle: this.form.InvoiceTitle,
        InvoiceName: this.form.InvoiceName,
        Accounts: this.form.Accounts,
        InvoiceItem: this.form.InvoiceItem,
        InvoiceType: this.form.InvoiceType,
        InvoiceKind: this.form.InvoiceKind,
        TaxpayerIdentifyNo: this.form.TaxpayerIdentifyNo,
        Email: this.form.Email,
        Remark: this.form.Remark,
        SettlementType: this.form.SettlementType,
        UserName: this.form.UserName,
        Phone: this.form.Phone,
        Address: this.form.Address
      };
      //  发请求
      that
        .postRequest({
          //  请求的url   api文件里面写的
          url: that.Api.InvoiceSave,
          params: param
        })
        .then(res => {
          this.modal.show = false;
          if (res.IsSuccess) {
            //  如果成功了
            this.$router.push({ path: "hotel" });
          } else {
            //  如果失败了
            this.error({ title: "提示", content: res.Msg || "保存失败" });
          }
        });
    },
    reset() {
      this.form = {
        OrderOrBillNo: "",
        InvoiceTitle: 0,
        InvoiceName: "",
        Accounts: "",
        InvoiceItem: 0,
        InvoiceType: 0,
        InvoiceKind: 0,
        TaxpayerIdentifyNo: "",
        Email: "",
        Remark: "",
        SettlementType: "",
        UserName: "",
        Phone: "",
        Address: ""
      };
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/invoice/information.vue